import styled from '@emotion/styled';

export const CreateProjectButton = styled.button`
  display: flex;
  width: 100%;
  height: 3rem;
  padding: 0.375rem 0.75rem;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: #4d4e58;
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  border-radius: 3.125rem;
  background: #f5f5f7;
  text-wrap: nowrap;
`;
type ExistingProjectButtonProps = { isCurrentProject: boolean };
export const ExistingProjectButton = styled.button<ExistingProjectButtonProps>`
  display: flex;
  padding: 0.3125rem 0.75rem 0.4375rem 0.75rem;
  justify-content: center;
  align-items: center;
  border-radius: 1.5rem;
  color: ${({ isCurrentProject }) => (isCurrentProject ? '#fff' : '#4D4E58')};
  background: ${({ isCurrentProject }) =>
    isCurrentProject ? '#4D4E58' : '#f5f5f7'};
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
`;

export const PanelWrapper = styled.div<{ openDirection: 'top' | 'bottom' }>`
  padding: 1rem;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.08);
  position: absolute;
  z-index: 4;
  ${({ openDirection }) =>
    openDirection === 'top'
      ? `
        bottom: calc(100% + 4px);
    `
      : `
        top: calc(100% + 4px);
    `}
`;
export const ProjectText = styled.span`
  color: #86868b;
`;
export const ProjectList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  max-width: 17.625rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 1rem;
`;

export const ToggleButton = styled.button<{ isOpen: boolean }>`
  display: flex;
  min-width: 8.875rem;
  height: 2rem;
  padding: 0.25rem 0.5rem;
  justify-content: center;
  align-items: center;
  border-radius: 3.125rem;
  background: ${({ isOpen }) => (!isOpen ? '#ffffff' : '#e4e4e4')};
  color: #4d4e58;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  font-size: 16px;
  max-width: 100%;
`;

export const ProjectTextWrapper = styled.div`
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
`;
